<script>
import { computedPbxBasePlans,computedPbxPlans } from '@/common/service/computers/plans/pbx';
import { PBX_GS } from '../helper/constants';
import { mapGetters } from 'vuex';
import Config from './config.vue';
import Edit from './edit.vue';
export default {
  props: {
    configPlanTileStatus: {
      type: Object,
      default: () => ({}),
    },
    isAddon: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    ...mapGetters(['boughtPlans','getSelectedPlans']),
    hasBoughtPbxBasePlan(){
      return !!computedPbxBasePlans(this.boughtPlans).length;
    },
    isGlobalSelect(){
      return computedPbxPlans(this.getSelectedPlans).some(item => PBX_GS.includes(item.category)) && this.$config('enableZoomPhoneGlobalSelect')
    },
  },
  render() {
    const context = {...{ props: { ...this.$attrs }, on: { ...this.$listeners }}};
    if (this.isGlobalSelect && this.$context.is.edit) return <Edit {...context} />;
    if (this.$context.is.edit) return <Edit {...context} />;
    if (this.$context.is.buyNow || this.$context.is.basic2pro) return <Config {...context} />;
    if (this.$context.is.add2cart){
      if(this.hasBoughtPbxBasePlan) return <Edit {...context} />;
      return <Config {...context} />;
    }
    return null;
  },
};
</script>